import { useMutation } from '@tanstack/react-query';
import { errorHandler } from '@app/utils/errorHandler';
import { ISelectOption } from '@widgets/multi-select';

export const fetch = async (): Promise<ISelectOption[]> => {
  return [
    { value: 'Перерегистрация', label: 'Перерегистрация' },
    { value: 'Нет ответа', label: 'Нет ответа' },
    {
      value: 'Утерян контакт с клиентом',
      label: 'Утерян контакт с клиентом',
    },
    { value: 'Проблемы на площадке', label: 'Проблемы на площадке' },
    { value: 'Переезд', label: 'Переезд' },
    { value: 'Продали оборудование', label: 'Продали оборудование' },
    { value: 'Временно не майнят', label: 'Временно не майнят' },
    { value: 'Низкие выплаты', label: 'Низкие выплаты' },
    { value: 'Не хватает функционала', label: 'Не хватает функционала' },
    { value: 'РКН', label: 'РКН' },
    { value: 'Свой пул', label: 'Свой пул' },
    { value: 'Курс BTC', label: 'Курс BTC' },
    { value: 'Лакрейт', label: 'Лакрейт' },
  ];
};

export const useAccountReasonOptions = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetch,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
